<template>
  <div>
    <b-modal :ref="`existRiderModal${index}`" @ok="confirmRemoveRider" :title="$t('general.notification')">
      <div class="my-4">
        <h5 v-html="notificationContent"></h5>
      </div>
      <b-alert :show="modalAlertCd" dismissible variant="danger" @dismissed="modalAlertCd=0">{{$t('general.updateError')}}</b-alert>
    </b-modal>
    <b-row class="my-1" align-v="center">
      <b-col cols="1">{{index+1}}.</b-col>
      <b-col cols="5">
        <b-row align-v="center">
          <b-col cols="3">{{$t('osm.contents.lifePolicy.generalInformation.productName')}}</b-col>
          <b-col cols="9">{{bilingualProductName}}</b-col>
        </b-row>
      </b-col>
      <b-col cols="4">
        <b-row align-v="center">
          <b-col cols="4">{{$t('osm.contents.lifePolicy.generalInformation.riders.riderPremium')}}</b-col>
          <b-col cols="8">$ {{riderDetail.riderPremium}}</b-col>
        </b-row>
      </b-col>
      <b-col cols="2">
        <!-- <b-btn variant="primary" @click="onClickAddRider" :disabled="isCreated" v-if="!isCreated">{{$t('general.add')}}</b-btn> -->
        <b-btn v-if="permissionLevel < 3.5" variant="danger" @click="onClickRemoveRider">{{$t('general.remove')}}</b-btn>
      </b-col>
    </b-row>
  </div>
</template>
<script type="text/javascript">
import Vue from 'vue'
import { mapState } from 'vuex'
export default {
  name: 'ExistedRiderRow',
  props: {
    bus: {
      type: Vue,
      required: true
    },
    index: {
      type: Number,
      required: true
    },
    riderDetail: {
      type: Object,
      required: true
    }
  },
  created() {
    this.getProductName();
  },
  computed: {
    permissionLevel(){
      return this.$store.state.permissionLevel;
    },
    ...mapState({
      policyID: state => state.LifePolicy.newLife.policyID,
    }),
    bilingualProductName() {
      var name = this.productName.english;
      if (this.productName != null && this.productName.chinese.length > 0) {
        name = name + '(' + this.productName.chinese + ")"
      }
      return name.length > 2 ? name : 'N/A';
    },

  },
  data() {
    return {
      riderInfo: { policyID: -1 },
      productName: { chinese: '', english: '' },
      modalAlertCd: 0,
      dismissSecs: 3,
      notificationContent: this.$t('osm.contents.general.addRiderConfirm'),
    }
  },
  methods: {
    showModalAlert() {
      this.modalAlertCd = this.dismissSecs;
    },
    closeRiderModal() {
      this.$refs['existRiderModal' + this.index].hide();
    },
    onClickRemoveRider() {
      Vue.set(this, 'notificationContent', this.$t('osm.contents.general.removeRiderConfirm', {
        name: this.bilingualProductName
      }));
      this.$refs['existRiderModal' + this.index].show();
    },
    confirmRemoveRider() {
      Vue.set(this.riderInfo, 'policyID', this.policyID);
      this.$store.dispatch('LifePolicy/removeLifeRider', this.riderDetail.ID).then((data) => {
        console.debug(data);
        this.bus.$emit('updateRiderSuccess', {
          remove: true,
          index: this.index
        });

      }).catch((error) => {
        this.showModalAlert();
      });
    },
    getProductName() {
      var productNamePayload = { optionType: "life", searchInput: { ID: this.riderDetail.productID } }
      this.searchOption(productNamePayload, (json) => {
        console.debug(json);
        Vue.set(this.productName, 'chinese', json[0].productChineseName);
        Vue.set(this.productName, 'english', json[0].productEnglishName);
      });
    },
    searchOption(obj, success) {
      var payload = {
        ...obj,
        ...{ dest: "option" },
      }
      this.$store.dispatch('searchOption', payload)
        .then((json) => {
          success(json);
        })
        .catch((err) => {
          console.debug(err);
        });
    },
  }
}

</script>



// WEBPACK FOOTER //
// src/Osm/LifePolicy/components/LifePolicyDetail/ExistedRiderRow.vue